import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { TimetableGridRow } from '../GridRow/TimetableGridRow';
import styles from './../TimetableGrid.module.scss';
import { useTimetableStore } from '../TimetableProvider';

type GridRowsProps = {
  daysWidth: string;
  cellWidth: string;
};

export const GridRows = observer(({ daysWidth, cellWidth }: GridRowsProps) => {
  const pinboardStore = useTimetableStore();

  const rows = pinboardStore.getRows();

  const isFullscreen = pinboardStore.isFullscreen;

  const classes = classNames(styles.board, {
    [styles['is-fullscreen']]: isFullscreen,
  });

  return (
    <div className={classes}>
      {rows.map((row) => {
        return <TimetableGridRow row={row} key={row.value} cellWidth={cellWidth} daysWidth={daysWidth} />;
      })}
    </div>
  );
});
